/* ======================================================================== */
/* 18. parallax */
/* ======================================================================== */
/* ======================================================================== */
/* Parallax */
/* ======================================================================== */
var Parallax = function ($scope) {

	var $target = $scope.find('.jarallax');

	if (!$target.length) {
		return;
	}

	$target.jarallax();

};
